import template from './dashboard-string-filter.component.html';
import type { InteractiveFilter } from '../../InteractiveFilter.model';
import type { IComponentController } from 'angular';

export class DashboardStringFilterController implements IComponentController {
	filter!: InteractiveFilter;

	private _value = '';
	$onInit() {
		if (typeof this.filter.value?.[0] === 'string') {
			this.value = this.filter.value?.[0];
		}

		this.filter.onChange(() => {
			this.handleExternalChanges();
		});
	}

	private handleExternalChanges() {
		this._value = typeof this.filter.value?.[0] === 'string' ? this.filter.value?.[0] : '';
	}

	get value() {
		return this._value;
	}

	set value(newValue: string) {
		this._value = newValue;
		if (newValue) {
			this.filter.setValue([newValue], this.filter.operators.Equals.getFullLabel(this.filter.title, [newValue]));
		} else {
			this.filter.clear();
		}
	}
}

export const DashboardStringFilterComponent = {
	name: 'mxDashboardStringFilter',
	controller: DashboardStringFilterController,
	controllerAs: 'vm',
	template,
	bindings: {
		filter: '<',
	},
};
